import React from 'react';
import ReactDOM from 'react-dom';
import {applyMiddleware, createStore} from 'redux';
import {Provider} from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import './index.css';
import ProductSlider from './components/ProductSlider';
import CustomPanelToggleBtn from './components/CustomPanelToggleBtn';
import ProductDetailOption from './components/ProductDetailOption';
import ProductAccordion from './components/ProductDetailImageList/ProductAccordion';
import Locale from "./components/Locale";
import rootReducer from './reducers';
import {debounce} from 'lodash';
import {
    currentLang,
    goPreviewPageByTag,
    loadCanvasData,
    loadProject,
    setCurrentProjectOption,
    setCustomText,
    setPrintDesignOption,
    toggleItemVisibility
} from './actions';
import rootSaga from './sagas';
import * as serviceWorkerRegistration from './serviceWorker';
//import { CaptureConsole } from '@sentry/integrations';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);

// START DUMMY PRODUCT DETAIL CALL
window.designEngine = window.designEngine || {};
window.designEngine.loadProject = (hash) => {
    return new Promise((resolve) => {
        return store.dispatch(loadProject(hash, (json) => {
            let locale = document.querySelector('html').getAttribute('lang').substr(0, 2) !== 'zh' ? 'en' : 'zh';
            store.dispatch(currentLang(locale));
            store.dispatch(loadCanvasData(json));
            if (document.getElementById('product-slider')) {
                ReactDOM.render(
                    <Provider store={store}>
                        <Locale locale={locale}>
                            <ProductSlider/>
                        </Locale>
                    </Provider>,
                    document.getElementById('product-slider'));
            }
            if (document.getElementById('product-options')) {
                ReactDOM.render(
                    <Provider store={store}>
                        <Locale locale={locale}>
                            <ProductDetailOption/>
                        </Locale>
                    </Provider>,
                    document.getElementById('product-options'));
            }
            if (document.getElementById('product-custom-text')) {
                ReactDOM.render(
                    <Provider store={store}>
                        <Locale locale={locale}>
                            <ProductAccordion/>
                        </Locale>
                    </Provider>,
                    document.getElementById('product-custom-text'));
            }

            if (document.getElementById('custom-btn')) {
                ReactDOM.render(
                    <Provider store={store}>
                        <Locale locale={locale}>
                            <CustomPanelToggleBtn/>
                        </Locale>
                    </Provider>,
                    document.getElementById('custom-btn'));
            }
            /*if (document.getElementById('xs-custom-panel')) {
              ReactDOM.render(
              <Provider store={store}>
                <MobileCustomPanel />
              </Provider>,
              document.getElementById('xs-custom-panel'));
            }*/

            resolve();
        }));

        // tempStore.hash = hash;
        // tempStore.currentOption = {'size': 'L', 'color': 'grey'};
    });
};

window.designEngine.setProductVariationChangeCallback = (callback) => {
    window.designEngine._productVariationChangeCallback = callback;
};

window.designEngine.setProductVariation = (key, value) => {
    return new Promise((resolve) => {
        if (key === "print_design") {
            store.dispatch(setPrintDesignOption(key, value));
        } else {
            store.dispatch(setCurrentProjectOption(key, value));
        }
        resolve();
    });
};

window.designEngine.setCustomText = (hash, text) => {
    return new Promise((resolve) => {
        store.dispatch(setCustomText(hash, text));
        resolve();
    });
};

window.designEngine.getImages = () => {
    let state = store.getState();
    //let projectOptionData = null;
    if (state.projectOptions && state.projectOptions.images && state.currentProjectOptions) {
        return {
            currentProjectOptions: state.currentProjectOptions,
            images: state.projectOptions.images
        };
    } else {
        return null;
    }

};

window.designEngine.getCurrentItemDetail = () => {
    return new Promise((resolve) => {
        let state = store.getState();
        let changes = {};
        for (let key in state.customTexts) {
            changes[key] = state.customTexts[key];
            if (state.wordwrapHints && state.wordwrapHints[key]) {
                changes[key].wordwrapHint = state.wordwrapHints[key];
            }
        }
        let projectOptionData = null;
        if (state.projectOptions && state.projectOptions.images && state.currentProjectOptions) {
            projectOptionData = state.projectOptions.images.find((projectOption) => {
                let match = true;
                for (let key in state.currentProjectOptions) {
                    let value = state.currentProjectOptions[key];
                    if (projectOption[key] !== value) {
                        match = false;
                    }
                }

                return match;
            });
        }

        resolve({
            hash: state.projectCode,
            variations: state.currentProjectOptions,
            changes: changes,
            projectOptionData: projectOptionData,
            selectedPreview: projectOptionData && projectOptionData.previews && projectOptionData.previews[state.previewPage ? state.previewPage : 0]
        });
    });
};

window.designEngine.showMobileCustomPanel = () => {
    return new Promise((resolve) => {
        store.dispatch(toggleItemVisibility('mobileCustomPanel'));
        resolve();
    });
};

window.designEngine.goPreviewPageByTag = (tag) => {
    return new Promise((resolve) => {
        store.dispatch(goPreviewPageByTag(tag));
        resolve()
    });
};

store.subscribe(() => {
    if (window.designEngine._productVariationChangeCallback) {
        window.designEngine.getCurrentItemDetail().then((data) => {
            let currentState = "projectOptions=" + JSON.stringify(data.variations) + "&changes=" + JSON.stringify(data.changes);
            if (currentState != window.designEngine._lastState) {
                window.designEngine._lastState = currentState;
                window.designEngine._productVariationChangeCallback(data.hash, data.variations, data.changes, data.projectOptionData, data.selectedPreview, debounce);
            }
        });
    }
});
serviceWorkerRegistration.register();
